module.exports = __webpack_public_path__ + "img/PDM-600-Mobile-GIS2.3bb3d240caba333e345a3578c63de2a1.avif";